import React, { Component } from "react";
import PropTypes from "prop-types";

// material-ui
import { withStyles } from "@material-ui/core/styles";

// custom
import Table from "components/TablePagination";

// styles
import styles from "./styles";

class EventsList extends Component {
  static propTypes = {
    // classes: PropTypes.object,
    events: PropTypes.array,
    onSelect: PropTypes.func,
  };

  onSelect(selectedEvent) {
    const { onSelect } = this.props;
    if (onSelect) {
      onSelect(selectedEvent);
    }
  }

  render() {
    const { events } = this.props;

    return (
      <Table
        data={events}
        meta={[
          {
            path: "title",
            title: "Title",
          },
        ]}
        title={"Events"}
        onRowSelect={this.onSelect.bind(this)}
      />
    );
  }
}

export default withStyles(styles)(EventsList);
